<template>
  <multiselect
    ref="multiselect"
    v-model="selectedTags"
    :options="currentOrganisation.businesses"
    :multiple="true"
    :taggable="false"
    :hide-selected="false"
    :show-labels="false"
    :show-no-results="true"
    :option-height="130"
    :disabled="false"
    :close-on-select="false"
    open-direction=""
    tag-placeholder=""
    :placeholder="multiselectIsOpened ? 'Search' : 'Select'"
    label="name"
    track-by="id"
    class="tag-multiselect2"
    :class="{ 'show-search': showSearch, 'hide-placeholder-after': selectedTags.length }"
    :searchable="showSearch"
    @search-change="findTagSearchChange"
    @input="valueChanged"
    @open="multiselectIsOpened = true"
    @close="multiselectIsOpened = false" >
    <div
      v-if="hasResults"
      slot="beforeList"
      class="multiselect-title">
      All numbers
    </div>
    <div
      slot="noOptions"
      ref="hideParent" />
    <div
      slot="noResult" >
      <p style="white-space: pre-wrap; text-align: center; line-height: 1.5;"><span class="emoji-fix inline">😐</span>&nbsp;We couldn't find anything for&nbsp;<b>{{ tagsSearchQuery }}</b></p>
    </div>
    <div
      slot="selection"
      slot-scope="{ values, remove }"
      class="tag-scroll-wrapper">
      <div class="scroll multiselect__tags-wrap">
        <span
          v-for="(number, index) in values"
          :key="index"
          class="multiselect__number flex center-all relative" >
          <VNodes
            :vnodes="getNumberIcon(number, 'business-icon no-shrink')" />
          <p>{{ number.name }}</p>
          <i
            class="multiselect__remove-icon no-shrink"
            @click.stop.prevent="remove(number)"
            @click.native="deleteTag(index, $event)"
            @mousedown.stop.prevent />
        </span>
      </div>
      <SBIcon
        class="down-arrow"
        :icon="SBIconList.DOWN_ARROW"
        :color="SBColors.greyPrimary"
        :size="11"
        :hover-size="30"/>
    </div>
    <div
      slot="option"
      slot-scope="{ option }"
      class="option flex" >
      <div class="branch-icon-wrapper flex center-all">
        <VNodes
          :vnodes="getNumberIcon(option, 'business-icon')" />
      </div>
      <div class="option-info">
        <h3 :inner-html.prop="option.name" />
        <p :inner-html.prop="option.phone" />
      </div>
    </div>
  </multiselect>
</template>


<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';

import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import VNodes from '@/components/common/VNodes';
import { getNumberIcon } from '@/helpers/lists/branchIcons';

export default {
  name: 'SBNumberMultiselect',
  components: {
    Multiselect,
    SBIcon,
    VNodes,
  },
  props: {
    value: {
      type: Array,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      selectedTags: [],
      tagsSearchQuery: '',
      multiselectIsOpened: false,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      currentOrganisation: 'organisation/currentOrganisation',
    }),
    hasResults() {
      return this.currentOrganisation.businesses.filter(number => number.name.toLowerCase().includes(this.tagsSearchQuery.toLowerCase())).length;
    },
    showSearch() {
      return this.currentOrganisation.businesses.length > 5;
    },
  },
  watch: {
    value: {
      handler() {
        if (this.value) {
          this.selectedTags = [...this.value];
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    getNumberIcon,
    deleteTag(index, event) {
      event.stopPropagation();
      event.preventDefault();
      this.selectedTags.splice(index, 1);
    },
    findTagSearchChange(searchQuery) {
      this.tagsSearchQuery = searchQuery;
    },
    valueChanged() {
      this.$emit('input', this.selectedTags);
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-multiselect2 ::v-deep {
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
  border: solid 1px $greyBorder;
  min-height: 30px !important;
  flex-wrap: nowrap;
  box-sizing: border-box;

  * {
    cursor: pointer !important;
  }

  .multiselect__content-wrapper {
    top: 34px;
    border-width: 0px;
    box-shadow: 0 2px 5px 0 rgba(13, 15, 22, 0.23);

    .multiselect__content {
      width: 100%;

      .multiselect__element {
        position: relative;

        .multiselect__option {

          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          &.multiselect__option--selected {
            &:not(:hover) {
              background-color: $white !important;
            }

            &::before {
              content: '';
              position: absolute;
              mask-image: url(~@/assets/img/SB-Icons/done-tick-blue.svg);
              mask-size: 9px 9px;
              mask-repeat: no-repeat;
              mask-position: 12px center;
              background-color: $bluePrimary;
              width: 30px;
              height: 100%;
              right: 7px;
              top: 0;
            }
          }

          .option {
            column-gap: 8px;

            .branch-icon-wrapper {
              width: 28px;
              height: 28px;
              border-radius: 5px;
              border: solid 1px #dde6e9;
              background-color: $white;
            }

            .option-info {
              
              h3 {
                margin: 0 !important;
                font-size: 14px !important;
                line-height: 1 !important;
                color: $blackPrimary !important;
              }

              p {
                margin: 0 !important;
                font-size: 11px !important;
                color: $blackUltralight !important;
              }
            }
          }
        }
      }
    }
  }

  .multiselect__tags {
    border: none;
    padding: 0 0 0 0;
    cursor: default;
    min-height: 0;

    .multiselect__tags-wrap {
      max-width: 100%;
      column-gap: 8px;

      .multiselect__tag {
        cursor: default;
        margin: 0 5px 2px 0;
        padding: 3px 6px 3px 8px;
        border-radius: 11px;
        background-color: #e7f1fe;
        overflow: unset;

        span {
          margin: 0 15px 0 0;
          font-size: 12px !important;
          font-weight: 500;
          line-height: 1.22;
          color: #2680eb;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }
      }
    }
  }

  .multiselect__select {
    // We decided not to show any "add tag" icon. If we decide to have it then just delete the line below and add padding-right to multiselect__tags with the value of __select width.
    display: none;

    width: 20px;
    height: 20px;
    right: 0;
    top: 0;
    padding: 0;
    margin: 0;
    mask-image: url(~@/assets/img/SB-Icons/plus.svg);
    mask-size: 8px 8px;
    background-color: $greyPrimary;
  }
}

.tag-multiselect2.show-search ::v-deep {
   .multiselect__content-wrapper {
    border-top: 44px solid #f8fafb !important;

    &::before {
      content: '';
      background-color: $greyUltralight;
      z-index: 99999;
      border-bottom: solid 1px $greyBorderModal;
      width: 100%;
      display: block;
      height: 0px;
      position: sticky;
      top: 0;
    }
  }
}

.tag-multiselect2 {
  &.multiselect--active ::v-deep {
    .multiselect__select {
      transform: rotateZ(90deg);
    }

    .multiselect__input {
      position: absolute;
      top: 34px;
      left: 0px;
      height: 26px;
      z-index: 99999;
      margin: 10px 12px;
      width: calc(100% - 24px) !important;
      padding: 5px 8px;

      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1) !important;
			border: solid 1px #cfd8dc !important;
			border-radius: 5px !important;

      &:hover {
				box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3) !important;
			}

			&:focus {
				outline: none !important;
				border: solid 1px #cfd8dc;
				box-shadow: 0 0 0 3px #bfdeff !important;
			}
    }
  }
}

.tag-scroll-wrapper {
  max-width: 100%;
  max-height: 30px;
  overflow: hidden;
}

.scroll {
  overflow-x: scroll;
  display: flex;
  column-gap: 0px;
  padding: 8px 0px 50px 10px;

  span {
    white-space: nowrap;
  }

  .branch-icon {
    width: 14px !important;
  }

  .multiselect__number {
    &:last-of-type {
      margin-right: 50px !important;
    }

    .business-icon {
      margin-right: 3px;
    }

    .multiselect__remove-icon {
      margin: 0 0 0 5px !important;
      right: 4px;
      top: 6px;
      bottom: 6px;
      width: 13px;
      height: 13px;
      background-image: unset !important;
      background-color: $greyPrimary !important;
      mask: url(̌̌~@/assets/img/SB-Icons/close-thin.svg) no-repeat center !important;
      mask-size: 8px 8px !important;
      cursor: pointer;

      &::after {
        display: none;
      }
    }
  }
}

.down-arrow {
  position: absolute;
  top: 0px;
  right: 0px;
  background: $white;

  &::before {
    content: '';
    width: 20px;
    left: -20px;
    height: 100%;
    background: linear-gradient(to right, rgba(255,255,255,0) , rgba(255,255,255,1));
    position: absolute;
  }
}

.tag-multiselect2.multiselect--active:not(.hide-placeholder-after) ::v-deep .multiselect__tags:after {
  content: 'Select';
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #9eafb5 !important;
  font-size: 14px !important;
}
</style>
